import ContactForm from "../../features/contactForm/ContactForm";
import "./ContactPage.css";

export default function ContactPage() {
    return (
        <section className="contactPage">
            <div className="top">
                <p id="tag">Start Your Custom Build</p>
                <h2>Contact the</h2>
                <h3>Workshop</h3>
                <p>Whether you need a convention-ready prop, modular dungeon terrain, or a custom dice box inscription, Quaking Aspen is ready to bring your idea to life.</p>
            </div>
            <div className="bottom">
                <ContactForm />
                <div className="right">
                    <div className="top-right">
                        <h4>Workshop Promise</h4>
                        <h5>Built with Detail. Crafted for Adventure.</h5>
                        <p>Every commission is carefully printed, assembled, and finished to create display-worthy fantasy pieces or accessories for tabletop gamers and collectors.</p>
                    </div>
                    <div className="bottom-right">
                        <h4>Quick Info</h4>
                        <h5>Average Response Time</h5>
                        <p>1-2 business days</p>
                        <h5>Popular Requests</h5>
                        <div className="tags">
                            <p>Dice Towers</p>
                            <p>Cosplay Props</p>
                            <p>Dungeon Terrain</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}